import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

import { BOUNDARY_ATTR } from './find-parent-boundary.directive';

/**
 * This directive works with the FindParentBoundaryDirective in order
 * to help setting the boundary property of a TwcSelect component
 * to a parent element exisiting in another component.
 * This directive will set the data-parent-boundary attribute in the current
 * element or in a children element matching the provided selector.
 * Then the FindParentBoundaryDirective will look for a parent with this
 * attribute and set it in the TwcSelect as the boundary.
 */
@Directive({
    selector: '[cwSetParentBoundary]',
    standalone: false,
})
export class SetParentBoundaryDirective implements AfterViewInit {
    /**
     * If a selector is given, a child matching that selector will be set as boundary
     * If no selector is given current element will be set as boundary
     */
    @Input('cwSetParentBoundary') selector = '';

    constructor(private elementRef: ElementRef<HTMLElement>) {}

    ngAfterViewInit(): void {
        const element = this.selector ? this.findChild() : this.elementRef.nativeElement;
        if (!element) {
            return;
        }

        if (element.hasAttribute(BOUNDARY_ATTR)) {
            return;
        }

        element.setAttribute(BOUNDARY_ATTR, '');
    }

    private findChild(): HTMLElement | null {
        return this.elementRef.nativeElement.querySelector(this.selector);
    }
}
